import React from "react";

// The athlete-tier taxonomy (mirror of AthleteTiers.cs - PROVISIONAL, see backend).
// Absent/unknown = unranked. elitePro is the curated reference tier: ASSIGNMENT is
// admin-only (mirror of AthleteTiers.IsAdminOnly; viewing/filtering stays open to all).
export const TIER_VALUES = ["elitePro", "pro", "eliteAmateur", "amateur", "beginner"] as const;

export const ADMIN_ONLY_TIERS: ReadonlySet<string> = new Set(["elitePro"]);

/** The tiers a user may ASSIGN from the Set-tier menu. */
export function assignableTiers(isAdmin: boolean): readonly string[] {
  return isAdmin ? TIER_VALUES : TIER_VALUES.filter((t) => !ADMIN_ONLY_TIERS.has(t));
}

export const TIER_LABELS: Record<string, string> = {
  elitePro: "Elite Pro",
  pro: "Pro",
  eliteAmateur: "Elite Am",
  amateur: "Amateur",
  beginner: "Beginner",
};

const TIER_CLASSES: Record<string, string> = {
  elitePro: "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  pro: "bg-violet-50 text-violet-700 border-violet-200",
  eliteAmateur: "bg-sky-50 text-sky-700 border-sky-200",
  amateur: "bg-emerald-50 text-emerald-700 border-emerald-200",
  beginner: "bg-amber-50 text-amber-700 border-amber-200",
};

/**
 * Small tier pill. Renders nothing for an absent/unknown tier unless `showUnranked`
 * is set (the rankings table wants an explicit "Unranked" chip; SessionDetail wants
 * no badge at all).
 */
export function TierBadge({ tier, showUnranked = false }: { tier?: string | null; showUnranked?: boolean }) {
  if (!tier || !TIER_LABELS[tier]) {
    if (!showUnranked) return null;
    return (
      <span className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[0.7rem] font-medium text-slate-500">
        Unranked
      </span>
    );
  }
  return (
    <span
      data-testid="tier-badge"
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[0.7rem] font-semibold ${TIER_CLASSES[tier]}`}
    >
      {TIER_LABELS[tier]}
    </span>
  );
}
